import SearchItem from './SearchItem';

export default SearchItem;



// WEBPACK FOOTER //
// ./src/components/Header/Search/SearchItem/index.js